import { Circle, Crown, Droplet, Flame, Gem, Heart, Leaf, Radiation, Shield, Skull, Star, Zap } from 'lucide-react';

/**
 * Symbole und Vorgaben der Teilnehmer-Marken, Spiegel von `COUNTER_ICONS` und `PRESET_COUNTERS`
 * in `backend/services/playtestRules.ts`: der Server lehnt jedes andere Symbol ab, deshalb
 * müssen Schlüssel und Reihenfolge übereinstimmen. Das erste Symbol ist die Vorgabe.
 */
export const COUNTER_ICONS = {
  circle: Circle,
  skull: Skull,
  zap: Zap,
  star: Star,
  radiation: Radiation,
  crown: Crown,
  shield: Shield,
  flame: Flame,
  droplet: Droplet,
  leaf: Leaf,
  gem: Gem,
  heart: Heart,
};

export const DEFAULT_COUNTER_ICON = 'circle';

export const PRESET_COUNTERS = [
  { id: 'poison', name: 'Gift', icon: 'droplet' },
  { id: 'energy', name: 'Energie', icon: 'zap' },
  { id: 'experience', name: 'Erfahrung', icon: 'star' },
  { id: 'rad', name: 'Rad', icon: 'radiation' },
  { id: 'commander-tax', name: 'Commander-Steuer', icon: 'crown' },
];

/** Grenze des Servers (`COUNTER_NAME_MAX_LENGTH`); länger zerreißt die Kopfzeile. */
export const COUNTER_NAME_MAX_LENGTH = 30;

/** Symbol-Komponente zu einem Backend-Namen; Unbekanntes fällt auf die Vorgabe zurück. */
export function counterIcon(name) {
  return COUNTER_ICONS[name] || COUNTER_ICONS[DEFAULT_COUNTER_ICON];
}
